import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import ReportsTable from '../../../../components/tables/ReportsTable';

const PayinReports = () => {
  // Sample data generator
  const generateSampleData = (count = 50) => {
    const statuses = ['Success', 'Pending', 'Failed'];
    const paymentGateways = ['Razorpay', 'PayU', 'Cashfree', 'Paytm', 'PhonePe'];
    const methods = ['UPI', 'Card', 'Net Banking', 'Wallet'];
    
    return Array.from({ length: count }, (_, i) => ({
      payinId: `PAYIN${String(i + 1).padStart(6, '0')}`,
      date: new Date(2024, Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
        .toISOString().split('T')[0],
      orderId: `ORD${Math.floor(Math.random() * 1000000000)}`,
      userId: `USER${String(Math.floor(Math.random() * 500) + 1).padStart(4, '0')}`,
      userName: `User ${Math.floor(Math.random() * 500) + 1}`,
      amount: (Math.random() * 20000 + 500).toFixed(2),
      gateway: paymentGateways[Math.floor(Math.random() * paymentGateways.length)],
      method: methods[Math.floor(Math.random() * methods.length)],
      gatewayTxnId: `GTW${Math.floor(Math.random() * 1000000000)}`,
      status: statuses[Math.floor(Math.random() * statuses.length)],
      charges: (Math.random() * 100 + 10).toFixed(2),
      netAmount: (Math.random() * 19900 + 450).toFixed(2)
    }));
  };

  const [data] = useState(generateSampleData(60));

  // Column definitions
  const columns = [
    { key: 'payinId', label: 'Payin ID' },
    { key: 'date', label: 'Date' },
    { key: 'orderId', label: 'Order ID' },
    { key: 'userId', label: 'User ID' },
    { key: 'userName', label: 'User Name' },
    { key: 'amount', label: 'Amount' },
    { key: 'gateway', label: 'Gateway' },
    { key: 'method', label: 'Method' },
    { key: 'gatewayTxnId', label: 'Gateway Txn ID' },
    { key: 'charges', label: 'Charges' },
    { key: 'netAmount', label: 'Net Amount' },
    { key: 'status', label: 'Status' }
  ];

  return (
    <Container fluid className="">
      <ReportsTable
        data={data}
        reportType="Payin_Reports"
        columns={columns}
        title="Payin Reports"
      />
    </Container>
  );
};

export default PayinReports;

